var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.clickedOutside,
          expression: "clickedOutside"
        }
      ],
      staticClass: "relative"
    },
    [
      _c("input", {
        ref: "input",
        class: _vm.inputClass,
        attrs: { placeholder: _vm.placeholder, tabindex: "0" },
        domProps: { value: _vm.value },
        on: { input: _vm.handleInput }
      }),
      _vm._v(" "),
      _vm.value
        ? _c(
            "span",
            {
              staticClass:
                "absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.reset()
                }
              }
            },
            [_vm._v("\n    x\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.value && _vm.showOptions,
              expression: "value && showOptions"
            }
          ],
          class: _vm.dropdownClass,
          attrs: { tabindex: "0" },
          on: {
            focusout: function($event) {
              _vm.showOptions = false
            }
          }
        },
        [
          _c(
            "ul",
            { staticClass: "py-1" },
            [
              _vm._l(_vm.searchResults, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "px-3 py-2 cursor-pointer hover:bg-gray-200",
                    on: {
                      click: function($event) {
                        return _vm.handleClick(item)
                      }
                    }
                  },
                  [_vm._v("\n        " + _vm._s(item.label) + "\n      ")]
                )
              }),
              _vm._v(" "),
              !_vm.searchResults.length
                ? _c("li", { staticClass: "px-3 py-2 text-center" }, [
                    _vm._v("\n        No Matching Results\n      ")
                  ])
                : _vm._e()
            ],
            2
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25b71a44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25b71a44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/InputAutoComplete.vue
// module id = null
// module chunks = 